export default __webpack_public_path__ + "assets/static/data/design-spynejs-data.json";